const refrigeratorType = 6;

export default refrigeratorType;
